import React, { useRef } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";

interface DropdownMenuProps {
  actionIsOpen: boolean;
  setActionIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onActionClick: (action: string) => void;
  // Pin state of the current selection: true = all selected are pinned (show
  // "Unpin"), false = show "Pin", null = nothing selected (default to "Pin").
  isPinned?: boolean | null;
}

const ActionDropdown: React.FC<DropdownMenuProps> = ({
  actionIsOpen,
  setActionIsOpen,
  onActionClick,
  isPinned,
}) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Handle click outside to close dropdown
  useClickOutside(dropdownRef, () => setActionIsOpen(false), true, "pointerdown");

  if (!actionIsOpen) return null;

  return (
    <div ref={dropdownRef}>
      <div
        id="dropdown-2"
        data-aspect="action-dropdown"
        className="absolute z-50 bg-white divide-y divide-gray-100 rounded-lg shadow-2xl border border-gray-200 py-1 w-44 max-w-[calc(100vw-1rem)] mt-2 right-0 max-sm:left-0 max-sm:right-auto origin-top-right"
      >
        <ul className="px-4 text-md text-gray-700">
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("pinFlight")}
            >
              <i className="st-thumbpin text-lightgray-150 text-md"></i>
              <p className="text-lightgray-150 text-md">
                {isPinned ? "Unpin Flight" : "Pin Flight"}
              </p>
            </a>
          </li>
          {/* <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("requestUpdate")}
            >
              <i className="st-reload text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md cursor-pointer">
                Request Update
              </p>
            </a>
          </li>
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("enableStatusUpdate")}
            >
              <i className="st-enable text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md">Enable Status Update</p>
            </a>
          </li> */}
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("deleteRequest")}
            >
              <i className="st-delete text-lightgray-150 text-md"></i>
              <p className="text-lightgray-150 text-md">Delete Request</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionDropdown;
